import React, { useState } from "react";
import "./puja-campaign-payment.scss";
import Image from "next/image";

import Btn from "../btn";
import PaymentModal from "./paymentModal";

import cameraFrame from "@/../public/campaign/puja-2025/camera-frame.png";

export default function Payment({
  onNextComp,
  capturedImg,
  userId,
  bgId,
  gender,
}) {
  const [isOpenPaymentModal, setIsOpenPaymentModal] = useState(false);
  const handlePay = () => {
    console.log("handle pay");
  };

  return (
    <div className="flex-col-center PujaCampaignPayment">
      <h1 className="pageHeading">ALMOST THERE</h1>

      <div className="flex-row-center userImgContainer">
        <Image
          src={capturedImg?.img}
          alt="captured image"
          className="uploadImg"
          width={720}
          height={720}
        />
        <Image
          src={cameraFrame}
          alt="camera"
          className="cameraFrame"
          width={720}
          height={720}
        />
        <div className="flex-col-center userImgOverlay">
          <p className="userImgOverlayText1">Your AI Masterpiece is Ready!</p>
          <p className="userImgOverlayText2">Unlock now and make it yours</p>
        </div>
      </div>

      <Btn btnTxt={"DOWNLOAD"} onClick={() => setIsOpenPaymentModal(true)} />

      {/* payment modal */}
      {isOpenPaymentModal && (
        <PaymentModal
          onNextComp={onNextComp}
          capturedImg={capturedImg}
          userId={userId}
          bgId={bgId}
          gender={gender}
        />
      )}
    </div>
  );
}
